import React, { createContext, useContext } from 'react';
import { useHrisIntegrationInfo } from '../Settings/hooks';

// Create the context
const AppContext = createContext();

// Provider component
export const AppProvider = ({ children, isAuthenticated }) => {
  const { hrisData, inviteDisabledInfo } = useHrisIntegrationInfo(
    isAuthenticated
  );

  return (
    <AppContext.Provider
      value={{
        hrisData,
        inviteDisabledInfo
      }}>
      {children}
    </AppContext.Provider>
  );
};

// Custom hook to consume the context
export const useAppContext = () => useContext(AppContext);
